import React, { useState } from "react";
import { Modal } from "../../components/admin/Modal";
import { UserForm } from "../../components/admin/UserForm";

export const UsersTab = ({ users, onSave, onDelete }) => {
  const [editingUser, setEditingUser] = useState(null);

  const handleSave = async (userData) => {
    await onSave(userData.id, userData);
    setEditingUser(null);
  };

  return (
    <div className="admin-section ">
      <div className="admin-header">
        <h2>Gestion des Utilisateurs</h2>
        <button className="btn-add" onClick={() => setEditingUser({})}>
          + Ajouter un utilisateur
        </button>
      </div>

      <Modal
        isOpen={!!editingUser}
        onClose={() => setEditingUser(null)}
        title={
          editingUser?.id
            ? "Modifier l'utilisateur"
            : "Nouvel utilisateur"
        }
      >
        <UserForm
          user={editingUser || {}}
          onSave={handleSave}
          onCancel={() => setEditingUser(null)}
        />
      </Modal>

      <div className="table-container">
        <div className="product-admin-table">
          <div className="product-header">
            <div>Prénom</div>
            <div>Nom</div>
            <div>Email</div>
            <div>Ville</div>
            <div>Téléphone</div>
            <div>Rôle</div>
            <div>Actions</div>
          </div>
          {users.map((user) => (
            <div className="product-row" key={user.id}>
              <div className="product-cell">{user.prenom}</div>
              <div className="product-cell">{user.nom}</div>
              <div className="product-cell">{user.email}</div>
              <div className="product-cell">{user.ville}</div>
              <div className="product-cell">{user.telephone}</div>
              <div className="product-cell">{user.role[0]}</div>
              <div className="product-cell admin-actions">
                <button
                  className="btn-edit"
                  onClick={() => setEditingUser(user)}
                >
                  <i className="bi bi-pencil"></i>
                </button>
                <button
                  className="btn-delete"
                  onClick={() => onDelete(user.id)}
                >
                  <i className="bi bi-trash"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
